var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 596,
    viewBox: "0 0 800 596",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M799.428 523.12H0.532227V523.519H799.428V523.12Z",
    fill: "#41525B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M719.379 548.828H595.438V549.228H719.379V548.828Z",
    fill: "#41525B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M533.124 543.236H444.718V543.636H533.124V543.236Z",
    fill: "#41525B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M664.861 534.001H570.56V534.4H664.861V534.001Z",
    fill: "#41525B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M104.628 536.685H84.3516V537.085H104.628V536.685Z",
    fill: "#41525B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M233.282 536.685H118.864V537.085H233.282V536.685Z",
    fill: "#41525B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M352.046 543.428H277.205V543.828H352.046V543.428Z",
    fill: "#41525B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M379.209 451.858H70.6914C68.2745 451.854 65.958 450.891 64.2505 449.18C62.543 447.47 61.584 445.152 61.584 442.735V9.04643C61.605 6.64339 62.5733 4.34569 64.2786 2.65242C65.9838 0.959141 68.2883 0.00704622 70.6914 0.00292969H379.209C381.629 0.00292969 383.949 0.964141 385.66 2.67511C387.371 4.38608 388.332 6.70664 388.332 9.12631V442.735C388.332 445.154 387.371 447.475 385.66 449.186C383.949 450.897 381.629 451.858 379.209 451.858ZM70.6914 0.322489C68.3804 0.326722 66.1656 1.24771 64.533 2.88331C62.9004 4.51891 61.9834 6.73546 61.9834 9.04643V442.735C61.9834 445.046 62.9004 447.262 64.533 448.898C66.1656 450.534 68.3804 451.454 70.6914 451.459H379.209C381.521 451.455 383.738 450.534 385.373 448.899C387.008 447.264 387.929 445.047 387.933 442.735V9.04643C387.929 6.73399 387.008 4.51748 385.373 2.88233C383.738 1.24719 381.521 0.326713 379.209 0.322489H70.6914Z",
    fill: "#41525B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M724.827 451.858H416.293C413.875 451.854 411.557 450.891 409.847 449.181C408.137 447.471 407.174 445.153 407.17 442.735V9.04643C407.195 6.64193 408.167 4.34425 409.875 2.65142C411.583 0.958582 413.889 0.00700132 416.293 0.00292969H724.827C727.227 0.0112454 729.527 0.965198 731.229 2.65802C732.931 4.35085 733.897 6.64615 733.918 9.04643V442.735C733.918 445.149 732.961 447.465 731.257 449.175C729.553 450.885 727.241 451.85 724.827 451.858ZM416.293 0.322489C413.981 0.326713 411.764 1.24719 410.129 2.88233C408.494 4.51748 407.574 6.73399 407.569 9.04643V442.735C407.574 445.047 408.494 447.264 410.129 448.899C411.764 450.534 413.981 451.455 416.293 451.459H724.827C727.139 451.455 729.356 450.534 730.991 448.899C732.626 447.264 733.546 445.047 733.551 442.735V9.04643C733.546 6.73399 732.626 4.51748 730.991 2.88233C729.356 1.24719 727.139 0.326713 724.827 0.322489H416.293Z",
    fill: "#41525B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M302.403 66.7588H90.5518V412.489H302.403V66.7588Z",
    fill: "#37474F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M308.875 66.7588H93.5723V412.489H308.875V66.7588Z",
    fill: "#1C262B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M302.403 412.489H90.5518V422.284H302.403V412.489Z",
    fill: "#37474F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M319.643 412.489H104.341V422.284H319.643V412.489Z",
    fill: "#1C262B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M299.814 403.429V75.8022L102.615 75.8022L102.615 403.429H299.814Z",
    fill: "#41525B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M147.081 403.429L172.278 75.8022H211.584L186.387 403.429H147.081Z",
    fill: "#37474F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M106.817 394.418C106.732 394.42 106.647 394.405 106.568 394.374C106.488 394.343 106.416 394.296 106.355 394.236C106.294 394.177 106.246 394.105 106.212 394.027C106.179 393.948 106.162 393.864 106.162 393.779V81.698C106.148 81.6045 106.153 81.5089 106.179 81.4178C106.205 81.3267 106.25 81.2423 106.311 81.1704C106.373 81.0984 106.449 81.0407 106.535 81.001C106.621 80.9614 106.715 80.9409 106.809 80.9409C106.904 80.9409 106.998 80.9614 107.084 81.001C107.17 81.0407 107.246 81.0984 107.307 81.1704C107.369 81.2423 107.414 81.3267 107.44 81.4178C107.466 81.5089 107.471 81.6045 107.456 81.698V393.779C107.456 393.862 107.44 393.946 107.408 394.023C107.376 394.101 107.329 394.171 107.269 394.23C107.21 394.29 107.14 394.337 107.062 394.369C106.984 394.401 106.901 394.418 106.817 394.418Z",
    fill: "#1C262B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M194.839 403.429L220.02 75.8022H235.343L210.162 403.429H194.839Z",
    fill: "#37474F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M299.814 403.429V75.8022H298.664V403.429H299.814Z",
    fill: "#37474F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M311.015 89.4479H99.1642L98.3174 79.3179H310.184L311.015 89.4479Z",
    fill: "#41525B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M311.015 106.065H99.1642L98.3174 95.9346H310.184L311.015 106.065Z",
    fill: "#41525B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M311.015 122.665H99.1642L98.3174 112.535H310.184L311.015 122.665Z",
    fill: "#41525B"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M311.015 139.283H99.1642L98.3174 129.153H310.184L311.015 139.283Z",
    fill: "#41525B"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M311.015 155.884H99.1642L98.3174 145.754H310.184L311.015 155.884Z",
    fill: "#41525B"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M311.015 172.501H99.1642L98.3174 162.371H310.184L311.015 172.501Z",
    fill: "#41525B"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M640.943 66.7588H437.928V523.12H640.943V66.7588Z",
    fill: "#1C262B"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M640.959 66.7588H442.226V523.12H640.959V66.7588Z",
    fill: "#37474F"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M628.831 512.766V77.1128L454.32 77.1128V512.766H628.831Z",
    fill: "#1C262B"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M471.48 158.184C471.48 145.565 476.494 133.462 485.417 124.539C494.34 115.615 506.443 110.602 519.063 110.602H564.12C570.368 110.602 576.555 111.833 582.327 114.224C588.099 116.616 593.343 120.121 597.76 124.54C602.178 128.958 605.681 134.204 608.07 139.977C610.46 145.749 611.689 151.936 611.687 158.184H471.48Z",
    fill: "#41525B"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M611.703 485.684V381.604H471.497V485.684H611.703Z",
    fill: "#37474F"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M471.466 368.182H533.316V187.488H471.466V368.182Z",
    fill: "#37474F"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M549.836 368.182H611.687V187.488H549.836V368.182Z",
    fill: "#37474F"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M589.254 277.012H614.595C615.638 277.012 616.638 276.598 617.375 275.861C618.112 275.124 618.526 274.124 618.526 273.081C618.522 272.04 618.106 271.043 617.37 270.307C616.634 269.571 615.637 269.155 614.595 269.151H589.254C588.215 269.155 587.219 269.571 586.485 270.308C585.752 271.044 585.34 272.042 585.34 273.081C585.34 274.121 585.752 275.118 586.485 275.855C587.219 276.592 588.215 277.008 589.254 277.012Z",
    fill: "#263238"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M628.831 512.767V77.1128H625.683V512.767H628.831Z",
    fill: "#1C262B"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M731.059 287.766H658.759L665.166 203.163H724.652L731.059 287.766Z",
    fill: "#41525B"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M715.192 287.766H702.761L700.125 203.163H711.597L715.192 287.766Z",
    fill: "#37474F"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M698.527 287.765H691.289V523.12H698.527V287.765Z",
    fill: "#1C262B"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M698.464 393.156H691.354C689.589 393.156 688.158 394.586 688.158 396.351V403.462C688.158 405.226 689.589 406.657 691.354 406.657H698.464C700.229 406.657 701.66 405.226 701.66 403.462V396.351C701.66 394.586 700.229 393.156 698.464 393.156Z",
    fill: "#1C262B"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M698.464 414.79H691.354C689.589 414.79 688.158 416.22 688.158 417.985V425.095C688.158 426.86 689.589 428.291 691.354 428.291H698.464C700.229 428.291 701.66 426.86 701.66 425.095V417.985C701.66 416.22 700.229 414.79 698.464 414.79Z",
    fill: "#1C262B"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M706.356 523.12H683.46C683.46 521.826 683.973 520.585 684.886 519.668C685.8 518.752 687.039 518.235 688.333 518.23H701.467C702.764 518.23 704.007 518.746 704.924 519.663C705.841 520.579 706.356 521.823 706.356 523.12Z",
    fill: "#1C262B"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M698.527 287.765H691.289V292.191H698.527V287.765Z",
    fill: "#263238"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M417.349 287.766H345.049L351.456 203.163H410.942L417.349 287.766Z",
    fill: "#41525B"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M401.481 287.766H389.05L386.414 203.163H397.886L401.481 287.766Z",
    fill: "#37474F"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M384.816 287.765H377.578V523.12H384.816V287.765Z",
    fill: "#1C262B"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M384.753 393.156H377.643C375.878 393.156 374.447 394.586 374.447 396.351V403.462C374.447 405.226 375.878 406.657 377.643 406.657H384.753C386.518 406.657 387.949 405.226 387.949 403.462V396.351C387.949 394.586 386.518 393.156 384.753 393.156Z",
    fill: "#1C262B"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M384.753 414.79H377.643C375.878 414.79 374.447 416.22 374.447 417.985V425.095C374.447 426.86 375.878 428.291 377.643 428.291H384.753C386.518 428.291 387.949 426.86 387.949 425.095V417.985C387.949 416.22 386.518 414.79 384.753 414.79Z",
    fill: "#1C262B"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M392.646 523.12H369.75C369.75 521.839 370.252 520.61 371.148 519.696C372.044 518.782 373.263 518.256 374.543 518.23H387.693C388.973 518.256 390.192 518.782 391.089 519.696C391.985 520.61 392.487 521.839 392.487 523.12H392.646Z",
    fill: "#1C262B"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M384.816 287.765H377.578V292.191H384.816V287.765Z",
    fill: "#263238"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M399.98 595.276C571.076 595.276 709.776 587.178 709.776 577.189C709.776 567.199 571.076 559.102 399.98 559.102C228.885 559.102 90.1846 567.199 90.1846 577.189C90.1846 587.178 228.885 595.276 399.98 595.276Z",
    fill: "#37474F"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M458.476 77.9751L455.473 170.232L527.805 165.23L458.476 77.9751Z",
    fill: "url(#paint0_linear_2162_6052)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M407.171 361.791L409.04 293.549L138.087 297.224L407.171 361.791Z",
    fill: "url(#paint1_linear_2162_6052)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M133.629 86.2036H461.176V292.319C461.176 293.649 460.647 294.925 459.707 295.866C458.766 296.807 457.49 297.336 456.159 297.336H138.646C137.987 297.336 137.335 297.206 136.726 296.954C136.117 296.702 135.564 296.332 135.098 295.866C134.632 295.4 134.263 294.847 134.011 294.239C133.759 293.63 133.629 292.978 133.629 292.319V86.2036Z",
    fill: "url(#paint2_linear_2162_6052)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M133.629 86.2036H461.176V292.319C461.176 293.649 460.647 294.925 459.707 295.866C458.766 296.807 457.49 297.336 456.159 297.336H138.646C137.987 297.336 137.335 297.206 136.726 296.954C136.117 296.702 135.564 296.332 135.098 295.866C134.632 295.4 134.263 294.847 134.011 294.239C133.759 293.63 133.629 292.978 133.629 292.319V86.2036Z",
    fill: "#37474F"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M428.214 99.9766H166.544C164.047 99.9766 162.022 102.001 162.022 104.498V178.045C162.022 180.542 164.047 182.566 166.544 182.566H428.214C430.712 182.566 432.736 180.542 432.736 178.045V104.498C432.736 102.001 430.712 99.9766 428.214 99.9766Z",
    fill: "#37474F"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M239.483 195.221H166.544C164.047 195.221 162.022 197.246 162.022 199.743V214.794C162.022 217.291 164.047 219.316 166.544 219.316H239.483C241.981 219.316 244.005 217.291 244.005 214.794V199.743C244.005 197.246 241.981 195.221 239.483 195.221Z",
    fill: "url(#paint3_linear_2162_6052)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M333.848 195.221H260.908C258.411 195.221 256.387 197.246 256.387 199.743V214.794C256.387 217.291 258.411 219.316 260.908 219.316H333.848C336.345 219.316 338.369 217.291 338.369 214.794V199.743C338.369 197.246 336.345 195.221 333.848 195.221Z",
    fill: "url(#paint4_linear_2162_6052)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M428.198 195.221H355.259C352.762 195.221 350.737 197.246 350.737 199.743V214.794C350.737 217.291 352.762 219.316 355.259 219.316H428.198C430.696 219.316 432.72 217.291 432.72 214.794V199.743C432.72 197.246 430.696 195.221 428.198 195.221Z",
    fill: "url(#paint5_linear_2162_6052)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M166.544 229.062H239.483C240.077 229.063 240.665 229.179 241.214 229.407C241.762 229.634 242.261 229.967 242.681 230.387C243.101 230.807 243.434 231.305 243.661 231.854C243.888 232.402 244.005 232.99 244.005 233.584V297.192H162.022V233.584C162.022 232.385 162.499 231.235 163.347 230.387C164.195 229.539 165.345 229.062 166.544 229.062Z",
    fill: "url(#paint6_linear_2162_6052)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M260.972 229.062H333.912C335.111 229.062 336.261 229.539 337.109 230.387C337.957 231.235 338.433 232.385 338.433 233.584V297.192H256.387V233.584C256.387 232.985 256.506 232.392 256.737 231.839C256.968 231.286 257.307 230.785 257.734 230.364C258.16 229.943 258.666 229.612 259.222 229.388C259.778 229.165 260.373 229.054 260.972 229.062Z",
    fill: "url(#paint7_linear_2162_6052)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M355.243 229.062H428.182C429.381 229.062 430.532 229.539 431.38 230.387C432.228 231.235 432.704 232.385 432.704 233.584V297.192H350.737V233.584C350.737 232.388 351.212 231.24 352.056 230.393C352.901 229.545 354.047 229.067 355.243 229.062Z",
    fill: "url(#paint8_linear_2162_6052)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M233.459 66.4072H225.47V68.005H233.459V66.4072Z",
    fill: "url(#paint9_linear_2162_6052)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M218.408 66.4072H198.835V68.005H218.408V66.4072Z",
    fill: "url(#paint10_linear_2162_6052)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M446.924 71.9996H147.833C145.961 71.9996 144.108 72.3696 142.379 73.0884C140.651 73.8073 139.081 74.8607 137.761 76.1882C136.441 77.5156 135.396 79.091 134.687 80.8235C133.978 82.5561 133.619 84.4118 133.629 86.2839H461.176C461.187 84.4078 460.826 82.5481 460.113 80.8124C459.401 79.0767 458.353 77.4992 457.027 76.1711C455.702 74.843 454.127 73.7906 452.393 73.0746C450.659 72.3586 448.8 71.9932 446.924 71.9996Z",
    fill: "url(#paint11_linear_2162_6052)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M153.745 79.0938C153.748 79.6576 153.583 80.2097 153.272 80.6798C152.961 81.15 152.517 81.517 151.996 81.7342C151.476 81.9514 150.903 82.0091 150.35 81.8999C149.797 81.7907 149.288 81.5195 148.89 81.1207C148.491 80.722 148.22 80.2138 148.111 79.6606C148.001 79.1075 148.059 78.5343 148.276 78.0139C148.493 77.4936 148.86 77.0496 149.331 76.7383C149.801 76.427 150.353 76.2625 150.917 76.2657C151.665 76.2699 152.382 76.5692 152.912 77.0986C153.441 77.6281 153.741 78.345 153.745 79.0938Z",
    fill: "#37474F"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M162.885 78.9497C162.885 79.509 162.719 80.0558 162.408 80.5209C162.097 80.9859 161.656 81.3484 161.139 81.5625C160.622 81.7765 160.053 81.8325 159.505 81.7234C158.956 81.6143 158.452 81.3449 158.057 80.9494C157.661 80.5539 157.392 80.05 157.283 79.5014C157.174 78.9528 157.23 78.3842 157.444 77.8674C157.658 77.3506 158.02 76.909 158.485 76.5982C158.95 76.2875 159.497 76.1216 160.057 76.1216C160.805 76.1258 161.522 76.4251 162.052 76.9545C162.581 77.484 162.881 78.2009 162.885 78.9497Z",
    fill: "#37474F"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M172.023 78.9497C172.023 79.509 171.857 80.0558 171.547 80.5209C171.236 80.9859 170.794 81.3484 170.278 81.5625C169.761 81.7765 169.192 81.8325 168.644 81.7234C168.095 81.6143 167.591 81.3449 167.196 80.9494C166.8 80.5539 166.531 80.05 166.422 79.5014C166.312 78.9528 166.368 78.3842 166.582 77.8674C166.797 77.3506 167.159 76.909 167.624 76.5982C168.089 76.2875 168.636 76.1216 169.195 76.1216C169.944 76.1258 170.661 76.4251 171.19 76.9545C171.72 77.484 172.019 78.2009 172.023 78.9497Z",
    fill: "#37474F"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M404.598 181.161H530.824V356.71C530.824 358.405 530.151 360.031 528.952 361.229C527.753 362.428 526.128 363.101 524.433 363.101H410.91C409.215 363.101 407.589 362.428 406.39 361.229C405.192 360.031 404.519 358.405 404.519 356.71V181.161H404.598Z",
    fill: "url(#paint12_linear_2162_6052)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M404.598 181.161H530.824V356.71C530.824 358.405 530.151 360.031 528.952 361.229C527.753 362.428 526.128 363.101 524.433 363.101H410.91C409.215 363.101 407.589 362.428 406.39 361.229C405.192 360.031 404.519 358.405 404.519 356.71V181.161H404.598Z",
    fill: "#37474F"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M516.14 190.651H419.234C417.505 190.651 416.103 192.053 416.103 193.783V227.081C416.103 228.811 417.505 230.213 419.234 230.213H516.14C517.87 230.213 519.272 228.811 519.272 227.081V193.783C519.272 192.053 517.87 190.651 516.14 190.651Z",
    fill: "#37474F"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M513.584 238.042H421.791C418.649 238.042 416.103 240.589 416.103 243.73V262.664C416.103 265.805 418.649 268.352 421.791 268.352H513.584C516.725 268.352 519.272 265.805 519.272 262.664V243.73C519.272 240.589 516.725 238.042 513.584 238.042Z",
    fill: "url(#paint13_linear_2162_6052)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M513.584 278.386H421.791C418.649 278.386 416.103 280.932 416.103 284.074V303.008C416.103 306.149 418.649 308.696 421.791 308.696H513.584C516.725 308.696 519.272 306.149 519.272 303.008V284.074C519.272 280.932 516.725 278.386 513.584 278.386Z",
    fill: "url(#paint14_linear_2162_6052)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M513.584 318.73H421.791C418.649 318.73 416.103 321.277 416.103 324.418V343.352C416.103 346.493 418.649 349.04 421.791 349.04H513.584C516.725 349.04 519.272 346.493 519.272 343.352V324.418C519.272 321.277 516.725 318.73 513.584 318.73Z",
    fill: "url(#paint15_linear_2162_6052)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M412.891 163.297H522.468C524.671 163.297 526.785 164.172 528.343 165.73C529.901 167.289 530.776 169.402 530.776 171.605V181.192H404.551V171.605C404.551 170.512 404.767 169.429 405.186 168.419C405.606 167.408 406.221 166.491 406.996 165.719C407.77 164.947 408.69 164.336 409.702 163.92C410.714 163.505 411.797 163.293 412.891 163.297Z",
    fill: "url(#paint16_linear_2162_6052)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2162_6052",
    x1: 473.79,
    y1: 65.8304,
    x2: 555.607,
    y2: 120.577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2162_6052",
    x1: 206.702,
    y1: 284.566,
    x2: 242.248,
    y2: 405.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2162_6052",
    x1: 216.576,
    y1: 58.4099,
    x2: 411.41,
    y2: 316.376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2162_6052",
    x1: 182.783,
    y1: 192.049,
    x2: 197.017,
    y2: 233.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2162_6052",
    x1: 277.148,
    y1: 192.049,
    x2: 291.381,
    y2: 233.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2162_6052",
    x1: 371.498,
    y1: 192.049,
    x2: 385.731,
    y2: 233.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2162_6052",
    x1: 182.783,
    y1: 220.094,
    x2: 248.124,
    y2: 287.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2162_6052",
    x1: 277.164,
    y1: 220.093,
    x2: 342.503,
    y2: 287.248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2162_6052",
    x1: 371.494,
    y1: 220.094,
    x2: 436.835,
    y2: 287.184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2162_6052",
    x1: 227.493,
    y1: 66.1969,
    x2: 228.174,
    y2: 69.1031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2162_6052",
    x1: 203.792,
    y1: 66.1969,
    x2: 204.082,
    y2: 69.2349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2162_6052",
    x1: 216.576,
    y1: 70.1191,
    x2: 217.973,
    y2: 97.4564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2162_6052",
    x1: 436.504,
    y1: 157.21,
    x2: 589.6,
    y2: 247.916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2162_6052",
    x1: 442.229,
    y1: 234.052,
    x2: 460.128,
    y2: 286.049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2162_6052",
    x1: 442.229,
    y1: 274.396,
    x2: 460.128,
    y2: 326.393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2162_6052",
    x1: 442.229,
    y1: 314.74,
    x2: 460.128,
    y2: 366.737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2162_6052",
    x1: 436.516,
    y1: 160.941,
    x2: 442.067,
    y2: 194.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage8);
export default __webpack_public_path__ + "static/media/Image 8.8fd4e578943a85cda342cf06357f41d7.svg";
export { ForwardRef as ReactComponent };